import { defineConfig } from "cva";

import { cn } from "./cn";

export const { cva, cx, compose } = defineConfig({
  hooks: {
    onComplete: cn
  }
});
